import { render } from "./CampaignDetail.vue?vue&type=template&id=423ac0ee&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"

import "./CampaignDetail.vue?vue&type=style&index=0&id=423ac0ee&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423ac0ee"]])

export default __exports__